(() => {
  const WISHLIST_KEY = 'leposse:wishlist:v1';
  const VISITOR_KEY = 'leposse:visitor:v1';
  const config = window.LePosseFeatures || {};

  const wishlistThumbnailUrl = (source, width) => {
    const raw = String(source || '').trim();
    if (!raw) return '';
    try {
      const url = new URL(raw, window.location.origin);
      const isShopifyImage = url.hostname === 'cdn.shopify.com' || url.hostname === window.location.hostname;
      if (!isShopifyImage) return raw;
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (_error) {
      return raw;
    }
  };

  const copy = {
    wishlistAdd: config.strings?.wishlistAdd || 'Add to wishlist',
    wishlistRemove: config.strings?.wishlistRemove || 'Remove from wishlist',
    bisSuccess: config.strings?.bisSuccess || 'You are on the list.',
    bisError: config.strings?.bisError || 'Something went wrong. Please try again.',
    bisPreview: config.strings?.bisPreview || 'This is a form preview. Notifications will start after the server is connected.',
    required: config.strings?.required || 'Complete all required fields.',
    loyaltyPoints: config.strings?.loyaltyPoints || 'Maison.92 points: __POINTS__',
    loyaltySubtext: config.strings?.loyaltySubtext || 'Collect points and redeem them for rewards with Maison.92 Club.',
  };

  const wishlistAvailabilityLabel = (state) => {
    const labels = {
      en: ['Checking…', 'Unavailable', 'Availability unconfirmed'],
      pl: ['Sprawdzanie…', 'Niedostępny', 'Brak potwierdzenia dostępności'],
      de: ['Wird geprüft…', 'Nicht verfügbar', 'Verfügbarkeit unbestätigt'],
      cs: ['Ověřování…', 'Nedostupné', 'Dostupnost neověřena'],
      sk: ['Overovanie…', 'Nedostupné', 'Dostupnosť nepotvrdená'],
      hu: ['Ellenőrzés…', 'Nem elérhető', 'Elérhetőség nem ellenőrzött'],
      el: ['Έλεγχος…', 'Μη διαθέσιμο', 'Μη επιβεβαιωμένη διαθεσιμότητα'],
      es: ['Comprobando…', 'No disponible', 'Disponibilidad sin confirmar'],
      fr: ['Vérification…', 'Indisponible', 'Disponibilité non confirmée'],
      it: ['Verifica…', 'Non disponibile', 'Disponibilità non confermata'],
    };
    const language = String(config.locale || document.documentElement.lang || 'en').toLowerCase().split('-')[0];
    return (labels[language] || labels.en)[state === 'checking' ? 0 : state === 'unknown' ? 2 : 1];
  };

  const loyaltyLabels = {
    ar: 'نقاط Maison.92: __POINTS__',
    bg: 'Точки Maison.92: __POINTS__',
    cs: 'Body Maison.92: __POINTS__',
    da: 'Maison.92-point: __POINTS__',
    de: 'Maison.92 Punkte: __POINTS__',
    el: 'Πόντοι Maison.92: __POINTS__',
    en: 'Maison.92 points: __POINTS__',
    es: 'Puntos Maison.92: __POINTS__',
    fi: 'Maison.92-pisteet: __POINTS__',
    fr: 'Points Maison.92 : __POINTS__',
    hr: 'Maison.92 bodovi: __POINTS__',
    hu: 'Maison.92 pontok: __POINTS__',
    it: 'Punti Maison.92: __POINTS__',
    ja: 'Maison.92ポイント：__POINTS__',
    ko: 'Maison.92 포인트: __POINTS__',
    lt: 'Maison.92 taškai: __POINTS__',
    nb: 'Maison.92-poeng: __POINTS__',
    nl: 'Maison.92-punten: __POINTS__',
    pl: 'Punkty Maison.92: __POINTS__',
    pt: 'Pontos Maison.92: __POINTS__',
    ro: 'Puncte Maison.92: __POINTS__',
    ru: 'Баллы Maison.92: __POINTS__',
    sk: 'Body Maison.92: __POINTS__',
    sl: 'Maison.92 točke: __POINTS__',
    sv: 'Maison.92-poäng: __POINTS__',
    tr: 'Maison.92 puanları: __POINTS__',
    uk: 'Бали Maison.92: __POINTS__',
    zh: 'Maison.92 积分：__POINTS__',
  };
  const loyaltyCache = new Map();
  const loyaltyRequests = new Map();

  const loyaltyLabel = (points) => {
    const language = (config.locale || document.documentElement.lang || 'en').toLowerCase().split('-')[0];
    const localizedTemplate = String(copy.loyaltyPoints || '');
    const template =
      localizedTemplate.includes('__POINTS__') && !localizedTemplate.toLowerCase().includes('translation missing')
        ? localizedTemplate
        : loyaltyLabels[language] || loyaltyLabels.en;
    return template.replace('__POINTS__', String(points));
  };

  const loyaltyApiUrl = (variantId) => {
    try {
      const configured = new URL(config.endpoint || '', window.location.origin);
      return `${configured.origin}/v1/loyalty/product-points?variant_id=${encodeURIComponent(variantId)}`;
    } catch (_error) {
      return '';
    }
  };

  const selectedVariantId = (main) => {
    const productForm = main.querySelector('form[id^="product-form-"]:not(.installment) input[name="id"]');
    const anyForm = main.querySelector('form[action*="/cart/add"] input[name="id"]');
    const id = String(productForm?.value || anyForm?.value || '').trim();
    return /^[0-9]{1,24}$/.test(id) ? id : '';
  };

  const ensureNativeLoyaltyBlock = (main) => {
    let block = main.querySelector('[data-lp-native-loyalty]');
    if (block) return block;
    const legacyPanel = main.querySelector('#loy-potential-points');
    const legacyBlock = legacyPanel?.closest('.shopify-app-block') || legacyPanel;
    const anchor =
      main.querySelector('.installment-wrapper') ||
      main.querySelector('.price-wrapper') ||
      main.querySelector('[id^="price-"]') ||
      main.querySelector('.price');
    if (!anchor && !legacyBlock) return null;
    block = document.createElement('div');
    block.className = 'lp-native-loyalty';
    block.dataset.lpNativeLoyalty = '';
    block.hidden = true;
    block.innerHTML = '<span class="lp-native-loyalty__label"></span>';
    if (anchor) anchor.insertAdjacentElement('afterend', block);
    else legacyBlock.insertAdjacentElement('beforebegin', block);
    return block;
  };

  const renderNativeLoyalty = (main, variantId, points) => {
    const block = ensureNativeLoyaltyBlock(main);
    const label = block?.querySelector('.lp-native-loyalty__label');
    if (!block || !label) return;
    label.textContent = loyaltyLabel(points);
    block.dataset.variantId = variantId;
    block.dataset.points = String(points);
    block.hidden = false;
    main.classList.add('lp-has-native-loyalty');
    main.querySelectorAll('#loy-potential-points').forEach((panel) => {
      const appBlock = panel.closest('.shopify-app-block');
      if (appBlock) appBlock.hidden = true;
      else panel.hidden = true;
    });
  };

  const isPrimaryProductInfo = (main) =>
    main instanceof Element && !main.closest('floated-form, .floated-form, .sticky-bar');

  const updateNativeLoyalty = async (scope = document) => {
    const mains = [];
    if (scope instanceof Element) {
      const closest = scope.closest('.product__info-main_content');
      if (isPrimaryProductInfo(closest)) mains.push(closest);
    }
    scope
      .querySelectorAll?.('.product__info-main_content')
      .forEach((main) => isPrimaryProductInfo(main) && mains.push(main));
    [...new Set(mains)].forEach(async (main) => {
      const variantId = selectedVariantId(main);
      const url = variantId ? loyaltyApiUrl(variantId) : '';
      if (!url) return;
      if (loyaltyCache.has(variantId)) {
        renderNativeLoyalty(main, variantId, loyaltyCache.get(variantId));
        return;
      }
      if (loyaltyRequests.has(variantId)) {
        try {
          renderNativeLoyalty(main, variantId, await loyaltyRequests.get(variantId));
        } catch (_error) {}
        return;
      }
      const request = fetch(url, { method: 'GET', mode: 'cors', credentials: 'omit' })
        .then((response) => {
          if (!response.ok) throw new Error('points_unavailable');
          return response.json();
        })
        .then((result) => {
          const points = Number(result?.points);
          if (!result?.ok || !Number.isInteger(points) || points < 0) throw new Error('points_unavailable');
          loyaltyCache.set(variantId, points);
          return points;
        })
        .finally(() => loyaltyRequests.delete(variantId));
      loyaltyRequests.set(variantId, request);
      try {
        const points = await request;
        if (selectedVariantId(main) === variantId) renderNativeLoyalty(main, variantId, points);
      } catch (_error) {
        // Rivo remains visible as a temporary fallback until the native endpoint answers.
      }
    });
  };

  const localizeLoyalty = (scope = document) => {
    const panels = [];
    if (scope instanceof Element) {
      const closestPanel = scope.matches('#loy-potential-points')
        ? scope
        : scope.closest('#loy-potential-points');
      if (closestPanel) panels.push(closestPanel);
    }
    scope.querySelectorAll?.('#loy-potential-points').forEach((panel) => panels.push(panel));

    panels.forEach((panel) => {
      const heading = panel.querySelector('h3');
      const subtext = panel.querySelector('p');
      const appBlock = panel.closest('.shopify-app-block');
      appBlock?.classList.add('lp-loyalty-block');
      appBlock?.parentElement?.classList.add('lp-has-loyalty-points');

      const explicitPoints = heading
        ?.querySelector('.order-placed-potential-points-amount')
        ?.textContent
        ?.trim();
      const numericTokens = heading?.textContent?.match(/[0-9]+(?:[\s.,][0-9]+)*/g) || [];
      const points = explicitPoints || numericTokens.at(-1)?.trim() || panel.dataset.lpPoints;
      if (!heading || !points) return;

      const label = loyaltyLabel(points);
      const currentLabel = heading.firstChild?.nodeType === Node.TEXT_NODE
        ? heading.firstChild.textContent?.trim()
        : '';
      const currentLink = heading.querySelector('.lp-loyalty-check');

      if (panel.dataset.lpPoints !== points || currentLabel !== label || currentLink) {
        heading.replaceChildren(document.createTextNode(label));
      }

      if (subtext) subtext.hidden = true;
      panel.dataset.lpPoints = points;
      panel.dataset.lpLocalized = config.locale || document.documentElement.lang || 'en';
    });
  };

  const parseJSON = (value, fallback) => {
    try {
      return JSON.parse(value);
    } catch (_error) {
      return fallback;
    }
  };

  const readStorage = (key, fallback) => {
    try {
      return parseJSON(localStorage.getItem(key), fallback);
    } catch (_error) {
      return fallback;
    }
  };

  const writeStorage = (key, value) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (_error) {
      return false;
    }
  };

  const formatPrice = (cents, fallback = '') => {
    if (!Number.isFinite(Number(cents))) return fallback;
    if (typeof window.formatMoney === 'function') {
      return window.formatMoney(Number(cents), window.theme?.moneyFormat || '');
    }
    try {
      return new Intl.NumberFormat(config.locale || document.documentElement.lang, {
        style: 'currency',
        currency: config.currency || 'PLN',
      }).format(Number(cents) / 100);
    } catch (_error) {
      return fallback;
    }
  };

  const getVisitorId = () => {
    try {
      const stored = localStorage.getItem(VISITOR_KEY);
      if (stored) return stored;
      const generated = window.crypto?.randomUUID?.() || `lp-${Date.now()}-${Math.random().toString(16).slice(2)}`;
      localStorage.setItem(VISITOR_KEY, generated);
      return generated;
    } catch (_error) {
      return '';
    }
  };

  const wishlist = {
    all() {
      const items = readStorage(WISHLIST_KEY, []);
      return Array.isArray(items) ? items.filter((item) => item && typeof item === 'object' && (typeof item.id === 'string' || typeof item.id === 'number') && String(item.id).trim() !== '') : [];
    },
    has(productId) {
      return this.all().some((item) => String(item.id) === String(productId));
    },
    toggle(product) {
      const current = this.all();
      const index = current.findIndex((item) => String(item.id) === String(product.id));
      let action = 'add';
      if (index >= 0) {
        current.splice(index, 1);
        action = 'remove';
      } else {
        current.unshift({ ...product, addedAt: new Date().toISOString() });
      }
      writeStorage(WISHLIST_KEY, current);
      document.dispatchEvent(new CustomEvent('leposse:wishlist-change', { detail: { action, product, items: current } }));
      track(`wishlist_${action}`, product);
      return action;
    },
    remove(productId) {
      const current = this.all();
      const product = current.find((item) => String(item.id) === String(productId));
      const next = current.filter((item) => String(item.id) !== String(productId));
      if (next.length === current.length) return;
      writeStorage(WISHLIST_KEY, next);
      document.dispatchEvent(new CustomEvent('leposse:wishlist-change', { detail: { action: 'remove', product, items: next } }));
      track('wishlist_remove', product || { id: productId });
    },
    replace(items) {
      writeStorage(WISHLIST_KEY, items);
    },
  };

  const eventContext = () => ({
    visitorId: getVisitorId(),
    customerId: config.customerId || null,
    currency: config.currency || null,
    locale: config.locale || document.documentElement.lang || null,
    page: window.location.pathname,
    occurredAt: new Date().toISOString(),
  });

  const postEvent = async (eventName, data) => {
    if (!config.endpoint) return { preview: true };
    const response = await fetch(config.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event: eventName, ...eventContext(), ...data }),
    });
    if (!response.ok) throw new Error(`Request failed (${response.status})`);
    const contentType = response.headers.get('content-type') || '';
    return contentType.includes('application/json') ? response.json() : { ok: true };
  };

  function track(eventName, product = {}) {
    const analyticsData = {
      product_id: String(product.id || ''),
      product_handle: product.handle || '',
      product_title: product.title || '',
      value: Number(product.price || 0) / 100,
      currency: config.currency || '',
    };

    try {
      window.Shopify?.analytics?.publish?.(`leposse_${eventName}`, analyticsData);
    } catch (_error) {
      // Shopify analytics is optional and should never block the storefront.
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: `leposse_${eventName}`, ...analyticsData });
    document.dispatchEvent(new CustomEvent(`leposse:${eventName}`, { detail: analyticsData }));

    if (config.endpoint && eventName.startsWith('wishlist_')) {
      postEvent(eventName, { product }).catch(() => {});
    }
  }

  const productFromButton = (button) => ({
    id: button.dataset.productId,
    handle: button.dataset.productHandle,
    url: button.dataset.productUrl,
    title: button.dataset.productTitle,
    image: button.dataset.productImage,
    price: Number(button.dataset.productPrice || 0),
    priceLabel: button.dataset.productPriceLabel,
    variantId: button.dataset.variantId,
    variantTitle: button.dataset.variantTitle,
    variantAvailable: button.dataset.variantAvailable === 'true',
  });

  const updateWishlistUI = () => {
    const items = wishlist.all();
    const itemIds = new Set(items.map((item) => String(item.id)));
    document.querySelectorAll('[data-lp-wishlist-toggle]').forEach((button) => {
      const added = itemIds.has(String(button.dataset.productId));
      button.setAttribute('aria-pressed', String(added));
      button.setAttribute('aria-label', added ? copy.wishlistRemove : copy.wishlistAdd);
      const label = button.querySelector('[data-lp-wishlist-label]');
      if (label) label.textContent = added ? copy.wishlistRemove : copy.wishlistAdd;
    });
    document.querySelectorAll('[data-lp-wishlist-count]').forEach((node) => {
      node.textContent = String(items.length);
      const count = node.closest('.lp-header-wishlist__count');
      if (count) count.hidden = false;
    });
  };

  if (!customElements.get('leposse-wishlist-drawer')) {
    customElements.define('leposse-wishlist-drawer', class extends HTMLElement {
      constructor() {
        super();
        this.closeTimer = null;
        this.openFrame = null;
        this.close = this.close.bind(this);
        this.handleKeyup = this.handleKeyup.bind(this);
      }

      connectedCallback() {
        this.querySelectorAll('[data-lp-wishlist-close]').forEach((button) => button.addEventListener('click', this.close));
        this.addEventListener('keyup', this.handleKeyup);
        this.render();
      }

      disconnectedCallback() {
        window.clearTimeout(this.closeTimer);
        window.cancelAnimationFrame(this.openFrame);
        document.body.classList.remove('lp-wishlist-open');
        this.querySelectorAll('[data-lp-wishlist-close]').forEach((button) => button.removeEventListener('click', this.close));
        this.removeEventListener('keyup', this.handleKeyup);
      }

      handleKeyup(event) {
        if (event.code === 'Escape') this.close();
      }

      open(trigger) {
        window.clearTimeout(this.closeTimer);
        window.cancelAnimationFrame(this.openFrame);
        this.activeElement = trigger || document.activeElement;
        this.render();
        this.refreshItems();
        this.classList.remove('active', 'closing');
        this.classList.add('animate');
        document.body.classList.add('lp-wishlist-open');
        this.openFrame = window.requestAnimationFrame(() => {
          this.openFrame = window.requestAnimationFrame(() => {
            this.classList.add('active');
            const focusTarget = this.querySelector('.lp-wishlist-drawer__inner');
            if (typeof trapFocus === 'function' && focusTarget) trapFocus(this, focusTarget);
          });
        });
      }

      async refreshItems() {
        const items = wishlist.all();
        const sequence = this.refreshSequence = (this.refreshSequence || 0) + 1;
        if (!items.length) { this.refreshingItems = false; this.render(); return; }
        this.refreshingItems = true;
        this.render();
        const localeRoot = String(config.rootUrl || '/').replace(/\/?$/, '/');
        const identity = (item) => JSON.stringify([String(item.id), String(item.variantId || ''), item.addedAt || '']);
        const refreshed = await Promise.all(items.map(async (item) => {
          const unavailable = (state) => ({ ...item, variantAvailable: false, availabilityLookup: state });
          if (!item.handle) return unavailable('unknown');
          const controller = new AbortController();
          const timer = setTimeout(() => controller.abort(), 8000);
          try {
            let response = await fetch(`${localeRoot}products/${encodeURIComponent(item.handle)}.js`, {
              headers: { Accept: 'application/json' }, signal: controller.signal,
            });
            if (response.status === 404 || response.status === 410) {
              const page = await fetch(`${localeRoot}products/${encodeURIComponent(item.handle)}`, {
                headers: { Accept: 'text/html' }, signal: controller.signal,
              });
              if (page.status === 404 || page.status === 410) return unavailable('missing');
              if (!page.ok) return unavailable('unknown');
              const target = new URL(page.url, window.location.origin);
              const match = target.pathname.match(/\/products\/([^/]+)\/?$/);
              if (target.origin !== window.location.origin || !match || decodeURIComponent(match[1]) === item.handle) return unavailable('unknown');
              response = await fetch(`${localeRoot}products/${encodeURIComponent(decodeURIComponent(match[1]))}.js`, {
                headers: { Accept: 'application/json' }, signal: controller.signal,
              });
            }
            if (!response.ok) return unavailable('unknown');
            const product = await response.json();
            if (String(product.id) !== String(item.id).replace(/^gid:\/\/shopify\/Product\//, '') || !Array.isArray(product.variants)) return unavailable('unknown');
            const variant = item.variantId
              ? product.variants.find((candidate) => String(candidate.id) === String(item.variantId))
              : product.variants.find((candidate) => candidate.available) || product.variants[0];
            if (!variant) return unavailable('variant_missing');
            return {
              ...item,
              handle: product.handle || item.handle,
              title: product.title || item.title || '',
              image: product.featured_image || item.image || '',
              variantId: String(variant.id),
              variantTitle: variant.title || '',
              variantAvailable: variant.available === true,
              availabilityLookup: 'verified',
              price: Number(variant.price ?? item.price ?? 0),
              priceLabel: formatPrice(variant.price, item.priceLabel),
            };
          } catch (_error) {
            return unavailable('unknown');
          } finally {
            clearTimeout(timer);
          }
        }));
        if (sequence !== this.refreshSequence) return;
        const updates = new Map(items.map((item, index) => [identity(item), refreshed[index]]));
        wishlist.replace(wishlist.all().map((item) => updates.get(identity(item)) || item));
        this.refreshingItems = false;
        this.render();
      }

      close() {
        if (
          !this.classList.contains('active') &&
          !this.classList.contains('animate') &&
          !document.body.classList.contains('lp-wishlist-open')
        ) return;
        window.cancelAnimationFrame(this.openFrame);
        this.classList.add('closing');
        this.classList.remove('active');
        document.body.classList.remove('lp-wishlist-open');
        if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);
        window.clearTimeout(this.closeTimer);
        this.closeTimer = window.setTimeout(() => this.classList.remove('animate', 'closing'), 450);
      }

      render() {
        const items = wishlist.all();
        const list = this.querySelector('[data-lp-wishlist-items]');
        const empty = this.querySelector('[data-lp-wishlist-empty]');
        const count = this.querySelector('[data-lp-wishlist-heading-count]');
        const template = this.querySelector('[data-lp-wishlist-item-template]');
        if (!list || !template) return;

        list.replaceChildren();
        empty.hidden = items.length > 0;
        count.textContent = items.length ? ` (${items.length})` : '';

        items.forEach((item) => {
          const fragment = template.content.cloneNode(true);
          const localeRoot = String(config.rootUrl || '/').replace(/\/?$/, '/');
          fragment.querySelectorAll('[data-lp-wishlist-item-link]').forEach((link) => {
            if (item.availabilityLookup === 'missing') link.removeAttribute('href');
            else link.href = item.handle ? `${localeRoot}products/${item.handle}` : item.url;
          });
          const image = fragment.querySelector('[data-lp-wishlist-item-image]');
          if (item.image) {
            const image1x = wishlistThumbnailUrl(item.image, 160);
            const image2x = wishlistThumbnailUrl(item.image, 320);
            image.src = image1x;
            if (image1x !== image2x) {
              image.srcset = `${image1x} 1x, ${image2x} 2x`;
              image.sizes = '160px';
            }
            image.alt = item.title || '';
          } else {
            image.remove();
          }
          fragment.querySelector('[data-lp-wishlist-item-title]').textContent = item.title || '';
          fragment.querySelector('[data-lp-wishlist-item-price]').textContent = item.priceLabel || '';
          const variant = fragment.querySelector('[data-lp-wishlist-item-variant]');
          if (item.variantTitle && item.variantTitle !== 'Default Title') {
            variant.textContent = item.variantTitle;
            variant.hidden = false;
          }
          const add = fragment.querySelector('[data-lp-wishlist-add-to-cart]');
          const unavailable = this.refreshingItems || !item.variantId || item.variantAvailable === false || item.variantAvailable === 'false';
          add.dataset.variantId = item.variantId || '';
          add.dataset.productId = item.id || '';
          add.dataset.productHandle = item.handle || '';
          add.dataset.productTitle = item.title || '';
          add.disabled = unavailable;
          add.querySelector('span').textContent = this.refreshingItems ? wishlistAvailabilityLabel('checking')
            : item.availabilityLookup && item.availabilityLookup !== 'verified' ? wishlistAvailabilityLabel(item.availabilityLookup)
            : unavailable ? add.dataset.unavailableLabel : add.dataset.defaultLabel;
          const remove = fragment.querySelector('[data-lp-wishlist-remove]');
          remove.dataset.productId = item.id;
          list.appendChild(fragment);
        });
      }
    });
  }

  const setBackInStockVariant = (component, variant) => {
    if (!component) return;
    if (!variant) {
      component.dataset.selectedVariantId = '';
      component.setAttribute('hidden', 'hidden');
      component.removeAttribute('disabled');
      component.querySelectorAll('input[name="variant_id"]').forEach((input) => {
        input.checked = false;
        input.disabled = true;
        const label = input.closest('[data-lp-bis-variant-label]');
        if (label) label.hidden = true;
      });
      return;
    }
    component.dataset.selectedVariantId = String(variant.id);
    component.removeAttribute('hidden');
    if (variant.available) component.removeAttribute('disabled');
    else component.setAttribute('disabled', 'disabled');
    const modal = document.querySelector(`[data-lp-bis-modal][data-product-id="${component.dataset.productId}"][data-section-id="${component.dataset.sectionId}"]`);
    const colorIndexText = component.dataset.colorOptionIndex;
    const colorIndex = colorIndexText != null && colorIndexText !== '' ? Number(colorIndexText) : null;
    const color = Number.isInteger(colorIndex) ? variant.options?.[colorIndex] : null;
    modal?.querySelectorAll('input[name="variant_id"]').forEach((input) => {
      const candidate = component.lpVariants?.find((item) => String(item.id) === String(input.value));
      const matches = Boolean(candidate && !candidate.available && (color == null || candidate.options?.[colorIndex] === color));
      const label = input.closest('[data-lp-bis-variant-label]');
      if (label) label.hidden = !matches;
      input.disabled = !matches;
      input.checked = matches && String(input.value) === String(variant.id);
    });
  };

  const addWishlistItemToCart = async (button) => {
    if (!button || button.disabled || button.classList.contains('loading')) return;
    const variantId = button.dataset.variantId;
    const error = button.closest('.lp-wishlist-item__content')?.querySelector('[data-lp-wishlist-item-error]');
    const label = button.querySelector('span');
    const originalLabel = label?.textContent || button.dataset.defaultLabel;
    if (!variantId) return;

    button.classList.add('loading');
    button.disabled = true;
    if (label) label.textContent = button.dataset.addingLabel;
    if (error) error.hidden = true;

    try {
      const cartDrawer = document.querySelector('cart-drawer');
      const sections = cartDrawer ? cartDrawer.getSectionsToRender().map((section) => section.id) : [];
      const rootUrl = window.Shopify?.routes?.root || config.rootUrl || '/';
      const response = await fetch(`${rootUrl}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1,
          properties: { _added_from_wishlist: 'true' },
          sections,
          sections_url: window.location.pathname,
        }),
      });
      const responseText = await response.text();
      let result;
      try {
        result = JSON.parse(responseText);
      } catch (_parseError) {
        throw new Error(button.dataset.errorLabel);
      }
      if (!response.ok || result.status) {
        throw new Error(result.description || button.dataset.errorLabel);
      }

      track('wishlist_add_to_cart', {
        id: button.dataset.productId,
        handle: button.dataset.productHandle,
        title: button.dataset.productTitle,
      });

      document.dispatchEvent(new CustomEvent('iig:cart-added', {
        detail: {
          source: 'customer',
          context: 'wishlist',
          productVariantId: String(variantId),
        },
      }));

      if (cartDrawer && result.sections) {
        const wishlistDrawer = document.querySelector('leposse-wishlist-drawer');
        const returnFocus = wishlistDrawer?.activeElement || document.querySelector('[data-lp-wishlist-trigger]') || button;
        wishlistDrawer?.close();
        window.setTimeout(() => {
          cartDrawer.setActiveElement(returnFocus);
          cartDrawer.renderContents(result);
        }, 420);
      } else {
        window.location.assign(`${rootUrl}cart`);
      }
    } catch (caughtError) {
      if (error) {
        error.textContent = caughtError.message || button.dataset.errorLabel;
        error.hidden = false;
      }
    } finally {
      button.classList.remove('loading');
      button.disabled = false;
      if (label) label.textContent = originalLabel;
    }
  };

  const initializeBackInStock = (root = document) => {
    const components = [];
    if (root instanceof Element && root.matches('leposse-back-in-stock')) components.push(root);
    root.querySelectorAll?.('leposse-back-in-stock').forEach((component) => components.push(component));
    components.forEach((component) => {
      if (component.dataset.lpBisReady === 'true') return;
      component.dataset.lpBisReady = 'true';
      const variants = parseJSON(component.querySelector('[data-lp-bis-variants]')?.textContent || '[]', []);
      component.lpVariants = variants;
      const selected = variants.find((variant) => String(variant.id) === String(component.dataset.selectedVariantId));
      if (selected) setBackInStockVariant(component, selected);
    });
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-lp-wishlist-toggle]');
    if (toggle) {
      event.preventDefault();
      wishlist.toggle(productFromButton(toggle));
      return;
    }

    const trigger = event.target.closest('[data-lp-wishlist-trigger]');
    if (trigger) {
      event.preventDefault();
      const mobileMenu = trigger.closest('header-drawer');
      if (mobileMenu?.mainDetailsToggle?.hasAttribute('open')) {
        mobileMenu.closeMenuDrawer(trigger);
      }
      document.querySelector('leposse-wishlist-drawer')?.open(trigger);
      return;
    }

    const remove = event.target.closest('[data-lp-wishlist-remove]');
    if (remove) {
      event.preventDefault();
      wishlist.remove(remove.dataset.productId);
      return;
    }

    const addToCart = event.target.closest('[data-lp-wishlist-add-to-cart]');
    if (addToCart) {
      event.preventDefault();
      addWishlistItemToCart(addToCart);
      return;
    }

    const backInStockOpener = event.target.closest('modal-opener[data-modal^="#LePosseBackInStockModal-"]');
    if (backInStockOpener) {
      const component = backInStockOpener.closest('leposse-back-in-stock');
      track('back_in_stock_opened', {
        id: component?.dataset.productId,
      });
    }
  });

  document.addEventListener('leposse:wishlist-change', () => {
    updateWishlistUI();
    document.querySelector('leposse-wishlist-drawer')?.render();
  });

  // The native picker emits variant:change only when a variant exists.
  // Its bubbling change arrives after updateMasterId, so clear a stale BIS
  // selection when the chosen option combination has no variant.
  document.addEventListener('change', (event) => {
    const picker = event.target instanceof Element ? event.target.closest('variant-selects, variant-radios') : null;
    if (!picker || picker.currentVariant) return;
    const sectionId = String(picker.dataset.section || '');
    document.querySelectorAll('leposse-back-in-stock').forEach((component) => {
      if (String(component.dataset.sectionId || '') === sectionId) setBackInStockVariant(component, null);
    });
  });

  document.addEventListener('variant:change', (event) => {
    const variant = event.detail?.variant;
    const sectionId = String(event.detail?.sectionId || '');
    if (!variant) return;
    document.querySelectorAll('[data-lp-wishlist-toggle]').forEach((button) => {
      if (String(button.dataset.sectionId || '') !== sectionId) return;
      button.dataset.variantId = String(variant.id);
      button.dataset.variantTitle = variant.title || '';
      button.dataset.variantAvailable = String(Boolean(variant.available));
      if (variant.price != null) {
        button.dataset.productPrice = String(variant.price);
        button.dataset.productPriceLabel = formatPrice(variant.price, button.dataset.productPriceLabel);
      }
    });
    document.querySelectorAll(`leposse-back-in-stock[data-section-id="${sectionId}"]`).forEach((component) => {
      const matchingVariant = component.lpVariants?.find((item) => String(item.id) === String(variant.id)) || variant;
      setBackInStockVariant(component, matchingVariant);
    });
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-lp-bis-form]');
    if (!form) return;
    event.preventDefault();

    const status = form.querySelector('[data-lp-bis-status]');
    const submit = form.querySelector('[type="submit"]');
    const spinner = submit?.querySelector('.loading-overlay__spinner');
    if (!form.reportValidity()) {
      status.textContent = copy.required;
      status.dataset.state = 'error';
      status.hidden = false;
      return;
    }

    const modal = form.closest('[data-lp-bis-modal]');
    const selected = form.querySelector('input[name="variant_id"]:checked');
    if (!selected || selected.disabled) {
      status.textContent = copy.required;
      status.dataset.state = 'error';
      status.hidden = false;
      return;
    }
    const payload = {
      product: {
        id: modal?.dataset.productId,
        handle: modal?.dataset.productHandle,
        title: modal?.dataset.productTitle,
      },
      variant: {
        id: selected?.value,
        title: selected?.dataset.variantTitle || '',
      },
      email: form.elements.email.value.trim(),
      consent: Boolean(form.elements.consent.checked),
    };

    submit.disabled = true;
    spinner?.classList.remove('hidden');
    status.hidden = true;

    try {
      const result = await postEvent('back_in_stock_subscribe', payload);
      status.textContent = result.preview ? copy.bisPreview : copy.bisSuccess;
      status.dataset.state = 'success';
      status.hidden = false;
      track('back_in_stock_submitted', {
        id: payload.product.id,
        handle: payload.product.handle,
        title: payload.product.title,
      });
      if (!result.preview) form.reset();
    } catch (_error) {
      status.textContent = copy.bisError;
      status.dataset.state = 'error';
      status.hidden = false;
    } finally {
      submit.disabled = false;
      spinner?.classList.add('hidden');
    }
  });

  const featureSelector = [
    'leposse-back-in-stock',
    '#loy-potential-points',
    '.product__info-main_content',
    '[data-lp-wishlist-toggle]',
    '[data-lp-wishlist-trigger]',
  ].join(',');
  const pendingFeatureRoots = new Set();
  let featureFlushFrame = null;

  const queueFeatureRoot = (node) => {
    if (!(node instanceof Element)) return;
    if (!node.matches(featureSelector) && !node.querySelector(featureSelector)) return;
    pendingFeatureRoots.add(node);
    if (featureFlushFrame !== null) return;
    featureFlushFrame = window.requestAnimationFrame(() => {
      featureFlushFrame = null;
      let wishlistUiAdded = false;
      pendingFeatureRoots.forEach((root) => {
        initializeBackInStock(root);
        localizeLoyalty(root);
        updateNativeLoyalty(root);
        if (
          root.matches('[data-lp-wishlist-toggle], [data-lp-wishlist-trigger]') ||
          root.querySelector('[data-lp-wishlist-toggle], [data-lp-wishlist-trigger]')
        ) {
          wishlistUiAdded = true;
        }
      });
      pendingFeatureRoots.clear();
      if (wishlistUiAdded) updateWishlistUI();
    });
  };

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.target instanceof Element && mutation.target.closest('#loy-potential-points')) {
        queueFeatureRoot(mutation.target.closest('#loy-potential-points'));
      }
      mutation.addedNodes.forEach(queueFeatureRoot);
    });
  });

  initializeBackInStock();
  localizeLoyalty();
  updateNativeLoyalty();
  document.addEventListener('change', (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('.product__info-main_content')) return;
    window.setTimeout(() => updateNativeLoyalty(event.target), 80);
  });
  updateWishlistUI();
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
